import { render, staticRenderFns } from "./UpdatePasswordForm.vue?vue&type=template&id=661d5850&scoped=true&"
import script from "./UpdatePasswordForm.vue?vue&type=script&lang=js&"
export * from "./UpdatePasswordForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "661d5850",
  null
  
)

export default component.exports